import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeRoof: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"home-roof, house"} maskId="square-filled-radius-0-stroke-1-IconHomeRoof"><path d="M22.6991 9.64103L12.0004 1.82971L1.30176 9.64103L1.89143 10.4487L4.00043 8.90885V21H20.0004L20.0004 8.90885L22.1094 10.4487L22.6991 9.64103Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHomeRoof;
